import { Route } from '@angular/router';
import { EpcRouteData } from '@epicuro-next/state/router-store';

export interface EpcRoute extends Route {
  path: string;
  data?: EpcRouteData;
  custom?: string;
  children?: EpcRoute[];
}

export type EpcRoutes = EpcRoute[];

export const enum PULSE_PRIVATE_ROUTE_KEY {
  SPOTLIGHT = 'spotlight',
  FOOTER = 'footer',
  MAIN_NAVIGATION = 'mainNavigation',
  HOME = 'home',
  BROWSE = 'browse',
  SEARCH = 'search',
  PRODUCT_LIST = 'productList',
  LOOKBOOK = 'lookBook',
  BASKET = 'basket',
  BASKET_MANAGER = 'basketManager',
  SCAN = 'scan',
  ORDER_BOOK = 'orderBook',
  STORY = 'story',
  SHOP_THE_LOOK = 'shopTheLook',
  PRIVACY_STATEMENT = 'privacyStatement',
  TRADE_TERMS = 'tradeTerms',
  USER_AGREEMENT = 'userAgreement',
  SUPPORT_PAGE = 'supportPage',
  CONTENT = 'content',
  BUILDER = 'builder',
  INFORMATION_BANNER = 'informationBanner',
  INVOICES = 'invoices',
  MOBILE_LISTS = 'mobileLists',
  MEDIA_RELATIONS = 'mediaRelations',
  /** @deprecated The routes doesnt exist anymore. This is only for redirection */
  HOME_NEWS_FEED = 'homeNewsFeed',
  /** @deprecated The routes doesnt exist anymore. This is only for redirection */
  HOME_LANDING_PAGE = 'homeLandingPage',
  /** @deprecated The routes doesnt exist anymore. This is only for redirection */
  HOME_LANDING_PAGE_STORY = 'homeLandingPageStory',
  DASHBOARD = 'dashboard',
  CMI = 'cmi',
  SELLER_TOOLS = 'sellerTools',
  BUDGET = 'budget',
  BASKET_REMINDER = 'basketReminder',
  LIVE_STREAM = 'liveStream',
  POCKETS = 'pockets',
}

export const enum PULSE_TOP_ROUTE_KEY {
  ACCOUNT_SELECTOR = 'accountSelector',
  USER_TERMS = 'userTerms',
  SITE_SELECTOR = 'siteSelector',
  CONFIG_STRIP = 'cs',
  URL_RESOLVER = 'urlResolver',
  AUTHENTICATION = 'authentication',
  OFFBOARDING = 'offboarding',
}

export const enum AUTH_ROUTE_KEY {
  LOGIN = 'login',
  LOGOUT = 'logout',
  FORGOT_PASSWORD = 'forgotPassword',
  RESET_PASSWOTD = 'resetPassword',
  WELCOME = 'welcome',
}

export const APP_PRIVATE_PATHS: {
  [key in PULSE_PRIVATE_ROUTE_KEY]: EpcRoute;
} = {
  spotlight: {
    path: '',
    outlet: 'spotlight',
  },
  footer: {
    path: '',
    outlet: 'footer',
  },
  mainNavigation: {
    path: '',
    outlet: 'main-navigation',
  },
  home: {
    path: 'home',
    data: {
      showSpotlight: false,
    },
  },
  browse: {
    path: 'browse',
  },
  search: {
    path: 'search',
  },
  productList: {
    path: 'product-lists',
  },
  shopTheLook: {
    path: 'shop-the-look',
  },
  lookBook: {
    path: 'look-book',
    data: {
      showSpotlight: false,
    },
  },
  basket: {
    path: 'basket',
  },
  basketManager: {
    path: 'basket-manager',
    data: {
      showSpotlight: true,
    },
  },
  scan: {
    path: 'scan',
    data: {
      showSpotlight: false,
    },
  },
  orderBook: {
    path: 'order-book',
    data: {
      showSpotlight: true,
    },
  },
  story: {
    path: 'story',
    data: {
      showSpotlight: false,
    },
  },
  privacyStatement: {
    path: 'privacy-statement',
    data: {
      showSpotlight: false,
    },
  },
  tradeTerms: {
    path: 'trade-terms',
    data: {
      showSpotlight: false,
    },
  },
  userAgreement: {
    path: 'user-agreement',
    data: {
      showSpotlight: false,
    },
  },
  supportPage: {
    path: 'support',
    data: {
      showSpotlight: false,
    },
  },
  content: {
    path: 'content',
    data: {
      showSpotlight: false,
    },
  },
  builder: {
    path: 'builder-content',
    data: {
      showSpotlight: false,
    },
  },
  [PULSE_PRIVATE_ROUTE_KEY.MEDIA_RELATIONS]: {
    path: 'media-relations',
    data: {
      showSpotlight: false,
    },
  },
  mobileLists: {
    path: 'lists',
  },
  [PULSE_PRIVATE_ROUTE_KEY.INFORMATION_BANNER]: {
    path: '',
    outlet: 'information-banner',
  },
  [PULSE_PRIVATE_ROUTE_KEY.INVOICES]: {
    path: 'invoices',
    data: {
      // showSpotlight: false,
    },
  },
  /** @deprecated The routes doesnt exist anymore. This is only for redirection */
  homeNewsFeed: {
    path: 'news-feed',
  },
  /** @deprecated The routes doesnt exist anymore. This is only for redirection */
  homeLandingPage: {
    path: 'landing-page',
  },
  /** @deprecated The routes doesnt exist anymore. This is only for redirection */
  homeLandingPageStory: {
    path: 'landing-page-story',
  },
  dashboard: {
    path: 'dashboard',
    data: {
      showSpotlight: false,
    },
  },
  liveStream: {
    path: 'live-stream',
  },
  pockets: {
    path: 'pockets',
  },
  [PULSE_PRIVATE_ROUTE_KEY.CMI]: {
    path: 'cmi',
    data: {
      showSpotlight: false,
    },
  },
  [PULSE_PRIVATE_ROUTE_KEY.SELLER_TOOLS]: {
    path: 'seller-tools',
  },
  [PULSE_PRIVATE_ROUTE_KEY.BUDGET]: {
    path: 'budget',
  },
  [PULSE_PRIVATE_ROUTE_KEY.BASKET_REMINDER]: {
    path: 'basket-reminder',
  },
};

export const APP_TOP_LEVEL_PATH: { [key in PULSE_TOP_ROUTE_KEY]: EpcRoute } = {
  accountSelector: {
    path: 'select-accounts',
    data: {
      showSpotlight: false,
    },
  },
  userTerms: {
    path: 'user-terms',
    data: {
      showSpotlight: false,
    },
  },
  siteSelector: {
    path: 'site-selector',
    custom: 's',
  },
  cs: {
    path: 'cs',
    outlet: 'overlay',
  },
  urlResolver: {
    path: 'url-resolver',
  },
  authentication: {
    path: 'authentication',
  },
  [PULSE_TOP_ROUTE_KEY.OFFBOARDING]: {
    path: 'unavailable',
  },
};

export const APP_AUTH_LEVEL_PATH: { [key in AUTH_ROUTE_KEY]: EpcRoute } = {
  login: {
    path: 'login',
  },
  logout: {
    path: 'logout',
  },
  forgotPassword: {
    path: 'forgot-password',
  },
  resetPassword: {
    path: 'reset-password',
  },
  welcome: {
    path: 'welcome',
  },
};

export const PRODUCT_LIST_SUBROUTES = {
  bulkAdd: 'add-multiple',
  create: 'create',
  commercial: 'commercial',
  edit: 'edit',
  root: ':id',
  promoteViaEmail: 'promote-email',
  promoteViaNewsFeed: 'promote-news-feed',
  promoteViaModalFeed: 'promote-modal-feed',
  promoteViaLandingPageFeed: 'promote-landing-page-feed',
  epicShow: 'epic-show',
  details: 'details',
  fancyList: 'fancy-list',
};

export const SHOP_THE_LOOK_SUBROUTES = {
  promote: 'promote',
};
